export default __webpack_public_path__ + "static/media/Image (7).3b1bc0e1.png";